<template>
  <div :disabled="!hasQuoteId">
    <div class="total_prices">
      <DotAlert
        v-for="price in adaptedPriceArray.prices"
        :key="price.type"
        :display-alert="getDotAlertConfig(price).displayAlert"
        :tooltip="getDotAlertConfig(price).tooltip"
      >
        <template #baseText>
          <div class="total_price_box">
            <div
              v-if="!isEditingPriceLevelLabelByType(price.type)"
              class="is-flex is-align-items-center"
            >
              <p class="is-relative">
                {{ price.label }}
              </p>

              <b-button
                v-if="isPriceTypeLabelEditable"
                style="border: none"
                :data-feature="featureName.PRICE_LEVEL_LABEL"
                @click="setEditingPriceLevelLabel(price.type)"
              >
                <i
                  class="button is-color4 is-info button-saas is-small sidebarEditButton"
                >
                  <IconPencil class="icon is-small" />
                </i>
              </b-button>
            </div>

            <div v-else class="is-flex is-align-items-center mb-3">
              <b-input
                v-model="price.label"
                type="text"
                placeholder="Price Level Label"
                class="price_level_label_input"
                @keyup.enter="setEditingPriceLevelLabel(price.type)"
              />

              <button
                class="btn_cancel_editing"
                @click="onClickCancelEditingPriceLevelLabel"
              >
                <IconClose />
              </button>
              <button
                class="btn_confirm_editing"
                data-action-type="PRICE_LEVEL_NAME_SAVE"
                @click="onClickConfirmEditingPriceLevelLabel"
              >
                <IconCheck />
              </button>
            </div>

            <span :id="price.type" class="level__price" type="number" disabled>
              {{ price.total }}
            </span>
          </div>
        </template>
      </DotAlert>
    </div>
    <div v-if="adaptedPaxsPrices.length > 0" class="pax_list">
      <PaxPriceCard
        v-for="(pax, index) in adaptedPaxsPrices"
        :key="index"
        :index="index"
        :pax="pax"
        :copy-pax-prices-changes="copyPaxPricesChanges"
        :calculate-total-pax-price="calculateTotalPaxPrice"
        :calculate-fields-by-total="calculateFieldsByTotal"
      />
    </div>
  </div>
</template>
<script>
import helpers from "@/helpers";
import { pricesHelper } from "@/utils/prices";
import { PRICE_TYPES, PRICE_LEVELS } from "@/constants/prices";
import PaxPriceCard from "./PaxPriceCard.vue";
import DotAlert from "../../_shared/DotAlert.vue";
import { mapGetters } from "vuex";
import { FEATURE_NAME } from "@/constants";

export default {
  name: "PriceTab",
  components: { PaxPriceCard, DotAlert },
  props: {
    priceArray: {
      type: Object,
      required: true,
    },
    paxsPrices: {
      type: Array,
      required: true,
    },
    levelsUpsalesAlert: {
      type: Array,
      required: true,
    },
    getDotAlertConfig: {
      type: Function,
      default: () => {},
    },
    savePaxsPrices: {
      type: Function,
      default: () => {},
    },
    handleModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      featureName: FEATURE_NAME,
      constants: { PRICE_TYPES, PRICE_LEVELS },
      helper: { ...helpers, ...pricesHelper },
      adaptedPaxsPrices: this.paxsPrices,
      adaptedPriceArray: this.priceArray,
      editingPriceLevelLabel: null,
    };
  },
  computed: {
    ...mapGetters({
      multipleSelectionEnabled: "utils/getMultipleSelectionEnabled",
    }),
    isPriceTypeLabelEditable() {
      return (
        !this.multipleSelectionEnabled &&
        this.adaptedPriceArray.type === this.constants.PRICE_TYPES.SELLER.type
      );
    },
    displayAlertByPriceType() {
      const resellerPrice = this.paxsPrices?.[0]?.price_levels.find(
        (price) => price.type === this.constants.PRICE_TYPES.RESELLER.type
      );
      if (resellerPrice === undefined) {
        return (
          this.adaptedPriceArray.type === this.constants.PRICE_TYPES.SELLER.type
        );
      } else {
        return (
          this.adaptedPriceArray.type ===
          this.constants.PRICE_TYPES.RESELLER.type
        );
      }
    },
    hasQuoteId() {
      return this.$route.query.itinerary !== undefined;
    },
  },
  watch: {
    adaptedPaxsPrices() {
      this.adaptedPriceArray = {
        ...this.adaptedPriceArray,
        prices: this.calculateTotalPriceLevels(),
      };
      this.udpateParentProps();
    },
  },
  mounted() {
    this.initialLoad();
  },
  methods: {
    async onClickConfirmEditingPriceLevelLabel() {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.setEditingPriceLevelLabel(null);

          this.udpateParentProps();

          await this.savePaxsPrices();

          this.$store.dispatch("itinerary/reloadQuoteServices");

          this.$buefy.toast.open({
            duration: 5000,
            message: `Price level label was saved successfully!`,
            position: "is-top",
            type: "is-success",
          });
        },
        functionToExecuteOnFail: async (error) => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Error trying to save the price level label",
            position: "is-top",
            type: "is-danger",
          });
          throw error;
        },
      });
    },
    onClickCancelEditingPriceLevelLabel() {
      this.setEditingPriceLevelLabel(null);
      this.adaptedPriceArray = {
        ...this.adaptedPriceArray,
        prices: this.calculateTotalPriceLevels(),
      };
    },
    isEditingPriceLevelLabelByType(priceType) {
      return this.editingPriceLevelLabel === priceType;
    },
    setEditingPriceLevelLabel(priceLevel) {
      this.editingPriceLevelLabel = priceLevel;
    },
    udpateParentProps() {
      const payload = {
        paxsPrices: this.adapterPaxsPricesToWrite(this.adaptedPaxsPrices),
        priceArray: this.adaptedPriceArray,
      };
      this.$emit("update", payload);
    },
    initialLoad() {
      const adaptedPaxsPrices = this.adapterPaxsPricesToRead(this.paxsPrices);
      this.adaptedPaxsPrices = this.filterPaxsPricesEmpty(adaptedPaxsPrices);
    },
    adapterPaxsPricesToWrite(paxsPrices = []) {
      return paxsPrices.map((pax, ind) => {
        const filteredPriceLevels = this.paxsPrices?.[ind].price_levels.filter(
          (priceLevel) => {
            return priceLevel.id !== this.priceArray.id;
          }
        );

        const mappedPaxPricesLevels = pax.price_levels.map((priceLevel) => {
          return {
            ...priceLevel,
            label: this.adaptedPriceArray.prices.find(
              (price) => price.level === priceLevel.level
            )?.label,
          };
        });

        return {
          ...pax,
          price_levels: [
            ...filteredPriceLevels,
            { ...this.priceArray, prices: mappedPaxPricesLevels },
          ],
        };
      });
    },
    adapterPaxsPricesToRead(paxsPrices = []) {
      return paxsPrices?.map((pax) => {
        const price_levels = pax.price_levels.find((priceLevel) => {
          return priceLevel.id === this.priceArray.id;
        });
        return { ...pax, price_levels: price_levels.prices };
      });
    },
    copyPaxPricesChanges(
      actionType = "",
      valueType = "",
      value = 0,
      paxLevel = {}
    ) {
      this.adaptedPaxsPrices = this.helper.calculatePaxPricesByActionType(
        this.adaptedPaxsPrices,
        actionType,
        valueType,
        value,
        paxLevel
      );
      return this.$buefy.toast.open({
        duration: 5000,
        message: "Pax Prices were updated sucessfully!",
        position: "is-top",
        type: "is-success",
      });
    },
    calculateTotalPaxPrice(fromMktPercentage = false) {
      const newPaxsPrices = this.adaptedPaxsPrices.map((pax) => {
        const newPax = { ...pax };
        const newPricesLevels = pax.price_levels.map((priceLevel) => {
          let newPriceLevel =
            pricesHelper.formatPaxPriceTo2Decimals(priceLevel);
          if (typeof fromMktPercentage === "boolean" && fromMktPercentage) {
            newPriceLevel.mkt_coin =
              (priceLevel.price * newPriceLevel.mkt_percentage) / 100;
          } else {
            newPriceLevel.mkt_percentage =
              (newPriceLevel.mkt_coin / newPriceLevel.price) * 100;
          }
          newPriceLevel.price = priceLevel.price;
          newPriceLevel.total_price = Math.round(
            newPriceLevel.price + newPriceLevel.mkt_coin + newPriceLevel.fee
          );
          return newPriceLevel;
        });
        return { ...newPax, price_levels: newPricesLevels };
      });
      this.adaptedPaxsPrices = this.filterPaxsPricesEmpty(newPaxsPrices);
    },
    calculateFieldsByTotal() {
      const newPaxsPrices = this.adaptedPaxsPrices.map((pax) => {
        const newPax = { ...pax };
        const newPricesLevels = pax.price_levels.map((priceLevel) => {
          let newPriceLevel =
            pricesHelper.formatPaxPriceTo2Decimals(priceLevel);
          newPriceLevel.price = priceLevel.price;

          if (priceLevel.price > 0) {
            const newMktCoin =
              priceLevel.total_price - (priceLevel.price + newPriceLevel.fee);
            const newMktPercentage =
              newMktCoin === 0
                ? 0
                : Number(((newMktCoin / newPriceLevel.price) * 100).toFixed(2));
            const newFee =
              priceLevel.total_price -
              (priceLevel.price + newPriceLevel.mkt_coin);

            if (newMktCoin >= 0) {
              newPriceLevel.mkt_coin = newMktCoin;
              newPriceLevel.mkt_percentage = newMktPercentage;
            } else if (newFee >= 0) {
              newPriceLevel.fee = newFee;
            }
          } else {
            newPriceLevel.fee = priceLevel.total_price - priceLevel.price;
          }

          return newPriceLevel;
        });
        return { ...newPax, price_levels: newPricesLevels };
      });
      this.adaptedPaxsPrices = newPaxsPrices;
    },
    calculateTotalPriceLevels() {
      if (this.adaptedPriceArray.prices.length === 0)
        return this.prices_itinerary_source;
      return this.helper.calculatePriceLevels(
        this.adaptedPriceArray.prices,
        this.adaptedPaxsPrices
      );
    },
    filterPaxsPricesEmpty(paxsPrices) {
      const newPaxsPricesFormattedToInteger =
        this.formatPaxPricesToInteger(paxsPrices);
      return newPaxsPricesFormattedToInteger;
    },
    formatPaxPricesToInteger(paxsPrices) {
      const newPaxsPrices = paxsPrices.map((pax) => {
        const newPricesLevels = pax.price_levels.map(
          pricesHelper.formatPaxPriceTo2Decimals
        );
        return { ...pax, price_levels: newPricesLevels };
      });
      return newPaxsPrices;
    },
  },
};
</script>
<style>
.total_prices {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 1rem;
}
.total_price_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 4rem;
  background-color: #ffffff;
  box-shadow: 0px 4px 50px -15px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  margin-bottom: 1rem;
}
.total_price_box p {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1d3b83;
}
.total_price_box .level__price {
  font-size: 1.2rem;
  font-weight: 600;
  color: #444444;
  width: 5rem;
  border: none;
  position: relative;
  left: 1rem;
}
.total_price_box level__price:focus {
  outline: none;
}
.pax_list {
  overflow-y: auto;
  max-height: 55vh;
  padding-bottom: 3rem;
}

.total_price_box
  :is(.btn_open_editing, .btn_confirm_editing, .btn_cancel_editing) {
  font-size: 0.8rem;
  border-radius: 50%;
  border: none;
  color: #fff;
  padding: 0.25rem 0.3rem;
}

.total_price_box
  :is(.btn_open_editing, .btn_confirm_editing, .btn_cancel_editing)
  svg {
  width: 0.8rem;
}

.total_price_box .btn_open_editing {
  background-color: #ff9316;
}

.total_price_box .btn_confirm_editing {
  background-color: #f00b81;
}

.total_price_box .btn_cancel_editing {
  background-color: white;
  color: #757575;
}

.price_level_label_input {
  width: 5rem;
}

.price_level_label_input input {
  font-size: 0.8rem;
}

@media screen and (max-width: 480px) {
  .total_prices {
    justify-content: space-between;
  }
  .pax_list {
    overflow-y: visible;
  }
}
</style>
